import PropTypes from "prop-types";
import React from "react";
import _ from "lodash";
import cx from "classnames";

import OverlayTrigger from "./base/OverlayTrigger";
import Tooltip from "./base/Tooltip";
import uiPrefix from "../utils/UiPrefixUtils";
import slugify from "../utils/SlugifyUtils";

function ControlBarButton(props) {
  const buttonRef = React.useRef(null);

  const { icons } = props;
  let plus = null;

  let leftMargin = 0;
  if (props.leftMargin) {
    leftMargin = props.leftMargin;
  }

  const style = {
    fontSize: 22,
    cursor: "pointer",
    height: "100%",
    marginLeft: leftMargin,
    position: "relative",
  };

  if (props.paddingLeft) {
    style.paddingLeft = props.paddingLeft;
  }

  if (props.paddingRight) {
    style.paddingRight = props.paddingRight;
  }

  if (props.overlay === "add") {
    plus = (
      <span className="controlbar-button-plus">
        <svg version="1.1" x="0px" y="0px" viewBox="0 0 6 6">
          <polygon points="6,2 4,2 4,0 2,0 2,2 0,2 0,4 2,4 2,6 4,6 4,4 6,4 " />
        </svg>
      </span>
    );
  }

  const btnStyle = {
    lineHeight: "50px",
    textDecoration: "none",
    display: "block",
    textAlign: "center",
    width: 40,
    height: "100%",
    position: "relative",
    borderBottom: 0,
  };
  let buttonTextLabel = null;
  if (props.label) {
    buttonTextLabel = (
      <label
        style={{
          fontSize: 14,
          marginBottom: 0,
          padding: "0 16px",
          alignItems: "center",
          display: "block",
          cursor: "pointer",
        }}
      >
        {props.label}
      </label>
    );
    btnStyle.width = "auto";
  }

  const classes = cx({
    "control-bar-btn": true,
    active: props.active,
    "btn-on": props.on,
  });

  const tooltipText = _.get(props, "title", "");

  let button = (
    <a
      ref={buttonRef}
      style={btnStyle}
      onClick={props.onClick}
      data-e2e={`${uiPrefix("control-bar-btn")}-${slugify(icons.replace("icon", ""))}`}
    >
      <span className={icons} />
      {plus}
      {buttonTextLabel}
    </a>
  );
  if (tooltipText !== "") {
    const tooltip = <Tooltip id="si-tooltip-control-bar-button">{tooltipText}</Tooltip>;
    button = (
      <OverlayTrigger overlay={tooltip} placement="top" offset={[0, 3]}>
        {button}
      </OverlayTrigger>
    );
  }

  return (
    <div
      slot={props.slot}
      style={style}
      data-e2e={uiPrefix("control-bar-btn-wrapper")}
      className={classes}
    >
      {button}
    </div>
  );
}

ControlBarButton.propTypes = {
  onClick: PropTypes.func,
  icons: PropTypes.string,
  active: PropTypes.bool,
  on: PropTypes.bool,
  title: PropTypes.string,
};

ControlBarButton.defaultProps = {
  active: false,
  on: false,
};

export default ControlBarButton;
